/**
 * When the Activity Map's Brief opens BY ITSELF — one rule for desktop web, mobile web, iOS and Android (the phones'
 * `ActivityMapLayout.briefAutoOpenDue`): once the map has settled (its counts are in) and there is a brief to show,
 * five seconds after, and only once a local calendar day. A Brief the reader opens by hand spends the day's showing
 * too. Remembered per browser (`localStorage`); where storage is unavailable, for the page session.
 *
 * Pure but for the storage pair, so the unit test reaches it without the app's graph.
 */

/** How long the map plays before the Brief opens by itself — a moment to take the map in first. */
export const BRIEF_AUTO_OPEN_DELAY_MS = 5_000;

const SEEN_DAY_KEY = 'symphony.activityMapBriefSeenDay';
let memorySeenDay: string | null = null;

export function localDayStamp(now: Date = new Date()): string {
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${now.getFullYear()}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`;
}

export function briefAutoOpenDue({ settled, hasBrief, seenDay, today }: { settled: boolean; hasBrief: boolean; seenDay: string | null; today: string }): boolean {
  return settled && hasBrief && seenDay !== today;
}

/** The day the Brief was last shown (by itself or by hand), or null. */
export function readBriefSeenDay(): string | null {
  try {
    return window.localStorage.getItem(SEEN_DAY_KEY) ?? memorySeenDay;
  } catch {
    return memorySeenDay;
  }
}

/** Spends today's showing — after an auto-open, and when the reader opens the Brief themselves. */
export function markBriefSeenToday(now: Date = new Date()): void {
  memorySeenDay = localDayStamp(now);
  try {
    window.localStorage.setItem(SEEN_DAY_KEY, memorySeenDay);
  } catch {
    // Storage blocked (a private window, a preview): the page session still remembers it.
  }
}
